import {
  Avatar,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Add as AddIcon, Forum as ForumIcon, OpenInNew as OpenInNewIcon } from "@material-ui/icons";
import { useQuery } from "@redux-requests/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { BaseLayout, Header, Loader } from "../components";
import { types } from "../ducks";
import { getForumTopics } from "../ducks/actions";
import { EditForumTopicDialog } from "../features/forum";
import { useInterval, useMediaQuery } from "../hooks";
import { ReactComponent as ForumSvg } from "../assets/icons/forum.svg";

const ForumPage = () => {
  const isSmallScreen = useMediaQuery("(max-width: 767px)");
  const useStyles = makeStyles(theme => ({
    root: {
      "& > *": {
        marginBottom: theme.spacing(3)
      }
    },
    actions: {
      textAlign: isSmallScreen ? "center" : "right"
    },
    topicBodyCard: {
      boxShadow: "none"
    },
    topicBody: {
      whiteSpace: "pre-line"
    },
    openTopic: {
      top: "0%",
      marginTop: "35px"
    },
    forumPostCount: {
      textAlign: "right"
    }
  }));

  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [forumTopic, setForumTopic] = useState(null);
  const [isPolling, setIsPolling] = useState(false);

  useEffect(() => dispatch(getForumTopics({})), [dispatch]);
  const {
    data: { data: forumTopics },
    loading: forumTopicsLoading
  } = useQuery({ type: types.GET_FORUM_TOPICS, defaultData: { data: [] } });

  useInterval(() => {
    setIsPolling(true);
    dispatch(getForumTopics({}));
  }, 30000);

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon={ForumSvg}
        title={intl.formatMessage({
          id: "Pages.ForumPage.Forum",
          defaultMessage: "Forum"
        })}
      />
      <Grid container>
        <Grid item xs={12} sm={6} md={8} lg={9} />
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className={classes.actions}>
            <Button variant="contained" color="primary" onClick={() => setForumTopic({})}>
              <AddIcon />
              &nbsp;
              {intl.formatMessage({
                id: "Pages.ForumPage.CreateNewTopic",
                defaultMessage: "Create New Topic"
              })}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Loader loading={!isPolling && forumTopicsLoading}>
            <List>
              {forumTopics.map(forumTopic => (
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <Avatar src={forumTopic.profile.avatarThumb}>
                      <ForumIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        {moment(forumTopic.createdAt).format("DD/MM/YYYY HH:mm")} by{" "}
                        {`${forumTopic.profile.title} ${forumTopic.profile.firstName} ${forumTopic.profile.lastName}`.trim()}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography variant="h6">
                          <strong>{forumTopic.title}</strong>
                        </Typography>
                        <br />
                        <Card className={classes.topicBodyCard}>
                          <CardContent>
                            <Typography variant="body1" className={classes.topicBody}>
                              {forumTopic.body}
                            </Typography>
                          </CardContent>
                        </Card>
                        <br />
                        <Typography variant="body2" className={classes.forumPostCount}>
                          <i>
                            {intl.formatMessage(
                              {
                                id: "Pages.ForumPage.ForumTopicPostCount",
                                defaultMessage: "There are {forumPostCount} posts in this topic."
                              },
                              { forumPostCount: forumTopic.forumPostCount }
                            )}
                          </i>
                        </Typography>
                      </>
                    }
                  />

                  <ListItemSecondaryAction className={classes.openTopic}>
                    <IconButton
                      edge="end"
                      aria-label="go"
                      component={Link}
                      to={`/forum-topic/${forumTopic.id}`}
                    >
                      <OpenInNewIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Loader>
        </Grid>
      </Grid>

      {Boolean(forumTopic) && <EditForumTopicDialog onClose={() => setForumTopic(false)} />}
    </BaseLayout>
  );
};
export default ForumPage;
